import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { resetModal } from '../actions/modalsActions';
import { setPaymentStatus } from '../actions/paymentActions';
import { paymentStatuses } from '../utils/constants';
import i18n from '../utils/i18n';
import Modal from './Modal';

const NoTrialWarningModal = ({
  resetModal: resetModalFunc,
  modalData,
  setPaymentStatus: setPaymentStatusFunc
}) => (
  <Modal
    isOpen={ true }
    onRequestClose={ () => {
      resetModalFunc();
      setPaymentStatusFunc(paymentStatuses.START, modalData.token);
    } }
    closeButtonText={ i18n.t('modals.cardUsed.CANCEL') }
    actionButtonText={ i18n.t('modals.cardUsed.BUY') }
    actionFunction={ () => {
      resetModalFunc();
      setPaymentStatusFunc(paymentStatuses.PROCESS_PAYMENT, modalData.token);
    } }
  >
    <div className="modal-container">
      <h1 className="modal-header">
        {i18n.t('modals.cardUsed.YOUR_CARD_USED')}
      </h1>
      <p>
        {i18n.t('modals.cardUsed.SUBMIT_QUESTION')}
        {' '}
        {i18n.t('modals.cardUsed.CHARGE_IMMEDIATELY')}
      </p>
    </div>
  </Modal>
);

NoTrialWarningModal.propTypes = {
  resetModal: PropTypes.func.isRequired,
  modalData: PropTypes.shape({
    token: PropTypes.string
  }),
  setPaymentStatus: PropTypes.func.isRequired
};

NoTrialWarningModal.defaultProps = {
  modalData: {
    token: ''
  }
};

const mapStateToProps = state => ({
  modalData: state.modals.modalData
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  resetModal: () => dispatch(resetModal()),
  setPaymentStatus: (paymentStatus, token) =>
    dispatch(setPaymentStatus(paymentStatus, token))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NoTrialWarningModal);



// WEBPACK FOOTER //
// ./src/modals/NoTrialWarningModal.js